import styled from 'styled-components';

export const Card = styled.div`
  background: ${({ theme }) => theme.color.white};
  border-radius: 20px;
  padding: 20px;
`;
